// extracted by mini-css-extract-plugin
export var matchStats = "stats-module--matchStats--Fku3y";
export var matchStats__bars_container = "stats-module--matchStats__bars_container--BxV8n";
export var matchStats__content = "stats-module--matchStats__content--f5yRC";
export var matchStats__logos = "stats-module--matchStats__logos--62bTb";
export var matchStats__src = "stats-module--matchStats__src--GE9UZ";
export var matchStats__texts = "stats-module--matchStats__texts--YXHWO";